<template>
  <div class="team-column" :style="{ top: top }">
    <div
      class="team icon wolves"
      :class="team === 'wolves' ? 'active' : ''"
      @click="$emit('update:team', 'wolves')"
    ></div>

    <div
      class="team icon la_liga"
      :class="team === 'la_liga' ? 'active' : ''"
      @click="$emit('update:team', 'la_liga')"
    ></div>
    <div
      class="team icon premier_league"
      :class="team === 'premier_league' ? 'active' : ''"
      @click="$emit('update:team', 'premier_league')"
    ></div>
    <div
      class="team icon serie_a"
      :class="team === 'serie_a' ? 'active' : ''"
      @click="$emit('update:team', 'serie_a')"
    ></div>
    <div
      class="team icon australia_a_league"
      :class="team === 'australia_a_league' ? 'active' : ''"
      @click="$emit('update:team', 'australia_a_league')"
    ></div>
  </div>
</template>
<script>
export default {
  name: "TeamColumn",
  props: ["team", "offset"],
  computed: {
    top() {
      return this.offset + "px";
    },
  },
};
</script>
<style lang="less" scoped>
.team-column {
  position: absolute;
  right: 0.2em;
  display: flex;
  height: auto;
  margin-top: 0vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: top 0.5s ease-out 0.12s;
  .team.icon {
    width: 1.6em;
    height: 1.6em;
    margin-bottom: 0.2em;
    z-index: 2;
    position: relative;
  }
  .team.icon::after {
    content: "";
    position: absolute;
    top: 0%;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all 0.16s;
    background-position: 50% 50%;
    background-size: 100%;
    background-repeat: no-repeat;
    transform: scale(0.8);
    border-radius: 100%;
  }
  .team.icon:hover::after,
  .team.icon.active::after {
    transform: scale(1);
  }

  .team.icon.active::after {
    border: 0.12em solid #f7b500;
    box-sizing: border-box;
    background-size: 120%;
  }

  .team.icon.wolves::after {
    background-image: url("../../assets/images/wolves/option.png");
  }
  .team.icon.wolves:hover::after,
  .team.icon.wolves.active::after {
    background-image: url("../../assets/images/wolves/option_hover.png");
  }

  .team.icon.la_liga::after {
    background-image: url("../../assets/images/la_liga/option.png");
  }
  .team.icon.la_liga:hover::after,
  .team.icon.la_liga.active::after {
    background-image: url("../../assets/images/la_liga/option_hover.png");
  }

  .team.icon.premier_league::after {
    background-image: url("../../assets/images/premier_league/option.png");
  }
  .team.icon.premier_league:hover::after,
  .team.icon.premier_league.active::after {
    background-image: url("../../assets/images/premier_league/option_hover.png");
  }

  .team.icon.serie_a::after {
    background-image: url("../../assets/images/serie_a/option.png");
  }
  .team.icon.serie_a:hover::after,
  .team.icon.serie_a.active::after {
    background-image: url("../../assets/images/serie_a/option_hover.png");
  }

  .team.icon.australia_a_league::after {
    background-image: url("../../assets/images/australia_a_league/option.png");
  }
  .team.icon.australia_a_league:hover::after,
  .team.icon.australia_a_league.active::after {
    background-image: url("../../assets/images/australia_a_league/option_hover.png");
  }
}
</style>



// WEBPACK FOOTER //
// src/components/section/teamCol.vue